import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FormattedTime, IntlProvider } from 'react-intl';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';

import i18n from '../../../i18n/i18n';

import Slider from '../../../components/Slider/Slider';
import Dropdown from '../../../components/Dropdown/Dropdown';
import Placeholder from '../../../components/Placeholder';
import Modal from '../../../components/Modal/RecieverDomElements';
import Accordion from '../../../components/Accordion/Accordion';
import CloseIcon from '../../../components/CloseIcon/CloseIcon';

import {
  Section,
  SectionInner,
  DropdownWrapper,
  List,
  SliderWrapper,
  ItemContent,
  Info,
  InfoLabel,
  InfoList,
  SeminarLink,
  Item,
  SeminarTitle,
  PlaceholderWrapper,
  SeminarListHeader,
  Address,
  LinkWrapper,
  Title,
  MobileDropdownWrapper,
  FilterBtn,
  FilterMenuWrapper,
  CloseBtnWrapper,
  CloseBtn,
  FilterTypeList,
  FiltersWrapper,
  FilterItem,
  Checkmark,
  FilterButtonWrapper,
  ClearBtn,
  ApplyBtn,
  NonLinkWrapper
} from './UpcomingSeminars.style';

const generateSeminars = (seminars, locale, copy) =>
  seminars.sort((a, b) => new Date(a.date).getTime() - new Date(b.date).getTime()).map(seminar => {
    const dateObj = new Date(seminar.date);
    const day = dateObj.getDate();
    const month = dateObj.getMonth();
    const monthName = i18n[locale].months[month];
    const year = dateObj.getFullYear();
    const yyyymmdd = `${year}/${("0" + (month + 1)).slice(-2)}/${("0" + day).slice(-2)}`;
    const seminarDurationHours = seminar.duration.split(':')[0];
    const seminarDurationMinutes = seminar.duration.split(':')[1];
    const duration =
      parseInt(seminarDurationHours, 10) * 60 * 60 * 1000 + parseInt(seminarDurationMinutes, 10) * 60 * 1000;

    return (
      <Item key={seminar.entryId}>
        <NonLinkWrapper>
          <ItemContent>
            <div>
              <SeminarTitle>{seminar.title}</SeminarTitle>
            </div>

            <InfoList>
              <Info>
                <InfoLabel>{copy.date ? `${copy.date}: ` : <Placeholder w="50px" h="18px" />}</InfoLabel>
                <p>
                  {yyyymmdd}
                </p>
              </Info>
              <Info>
                <InfoLabel>{copy.time ? `${copy.time}: ` : <Placeholder w="50px" h="18px" />}</InfoLabel>
                <p>
                  <IntlProvider locale={locale.split('_')[0]}>
                    <Fragment>
                      <FormattedTime value={dateObj} /> -{' '}
                      <FormattedTime value={new Date(dateObj.getTime() + duration)} />
                    </Fragment>
                  </IntlProvider>
                </p>
              </Info>
              {seminar.instructor && seminar.instructor.name && seminar.instructor.name != '' ? (
                <Info>
                  <InfoLabel>{copy.instructor ? `${copy.instructor}: ` : <Placeholder w="50px" h="18px" />}</InfoLabel>
                  <p>{seminar.instructor.name}</p>
                </Info>
              ) : null}
            </InfoList>

            <SeminarLink>{/* copy.sign_up || <Placeholder w="100px" h="25px" /> */}</SeminarLink>
          </ItemContent>
        </NonLinkWrapper>
      </Item>
    );
  });

class UpcomingSeminars extends Component {
  state = {
    seminars: this.props.seminars,
    location: ['All'],
    isFilterMenuOpen: false,
  };

  componentWillReceiveProps(nextProps) {
    if (JSON.stringify(this.props.seminars) !== JSON.stringify(nextProps.seminars)) {
      this.setState({
        seminars: nextProps.seminars,
      });
    }
  }

  validSeminars = (seminars, type, filters) =>
    seminars.filter(seminar => {
      if (filters[0] === 'All') {
        return true;
      }
      const filtersMatch = filters.map(filter => {
        if (Array.isArray(seminar[type])) {
          return !!seminar[type].find(entry => entry === filter);
        }
        return seminar[type] === filter;
      });

      return filtersMatch.find(match => match);
    });

  handleFilterSeminars = (type, filter) => () => {
    const { seminars } = this.props;
    let { location } = this.state;
    if (filter === 'All') {
      location = ['All'];
    } else if (location.find(loc => loc === filter)) {
      location = location.filter(loc => loc !== filter);
      if (location.length === 0) location = ['All'];
    } else {
      location = [...new Set(location.filter(loc => loc !== 'All').concat(filter))];
    }

    this.setState({
      seminars: location[0] !== 'All' ? seminars.filter(({ city }) => location.find(loc => loc === city)) : seminars,
      location: location[0] !== 'All' ? location : ['All'],
    });
  };

  handleToggleFilterOverlay = () => {
    this.setState(({ isFilterMenuOpen }) => ({ isFilterMenuOpen: !isFilterMenuOpen }));
  };

  handleClearFilters = () => {
    this.setState({
      seminars: this.props.seminars,
      location: ['All'],
      isFilterMenuOpen: false,
    });
  };

  handleRemoveFilter = (type, filter) => () => {
    const { seminars } = this.props;
    let { location } = this.state;
    location = location.filter(loc => loc !== filter);
    if (location.length === 0) location = ['All'];

    this.setState({
      seminars:
        location[0] !== 'All' ? seminars.filter(({ location }) => location.find(loc => loc === location)) : seminars,
      location: location[0] !== 'All' ? location : ['All'],
    });
  };

  render() {
    const { copy, locale, seminars: allSeminars } = this.props;
    const { seminars, location, isFilterMenuOpen } = this.state;
    const cities = [...new Set(allSeminars.map(seminar => seminar.location))];

    return (
      <Section>
        <Helmet>
          <body style={`overflow: ${isFilterMenuOpen ? 'hidden' : 'auto'};`} />
        </Helmet>
        <SectionInner>
          <Title>{copy.upcoming_seminars || <Placeholder w="100px" h="20px" />}</Title>
          <DropdownWrapper>
            {seminars.length > 0 ? (
              <Dropdown
                name="location"
                activeOptions={location}
                label={copy.see_all_location || <Placeholder w="100px" h="20px" />}
                options={cities}
                onSelect={this.handleFilterSeminars}
                onRemoveFilter={this.handleRemoveFilter}
              />
            ) : (
              <PlaceholderWrapper>
                <Placeholder h="72px" w="100%" />
              </PlaceholderWrapper>
            )}
          </DropdownWrapper>
          <MobileDropdownWrapper>
            {seminars.length > 0 ? (
              <Fragment>
                <FilterBtn onClick={this.handleToggleFilterOverlay}>
                  {copy.see_all_location || <Placeholder w="100px" h="20px" />}
                </FilterBtn>
                {isFilterMenuOpen && (
                  <Modal>
                    <FilterMenuWrapper>
                      <CloseBtnWrapper>
                        <CloseBtn onClick={this.handleToggleFilterOverlay}>
                          <CloseIcon />
                        </CloseBtn>
                      </CloseBtnWrapper>
                      <FilterTypeList>
                        <Accordion
                          title="Location"
                          contentHeight={(cities.length + 1) * 45 + 30 /* FilterWrapper padding + FilterItem height */}
                        >
                          <FiltersWrapper>
                            <FilterItem
                              onClick={this.handleFilterSeminars('location', 'All')}
                              selected={!!location.find(loc => loc === 'All')}
                            >
                              <Checkmark />
                              <span>All</span>
                            </FilterItem>
                            {cities.map(filter => (
                              <FilterItem
                                onClick={this.handleFilterSeminars('location', filter)}
                                key={filter}
                                selected={!!location.find(loc => loc === filter)}
                              >
                                <Checkmark />
                                <span>{filter}</span>
                              </FilterItem>
                            ))}
                          </FiltersWrapper>
                        </Accordion>
                      </FilterTypeList>
                      <FilterButtonWrapper>
                        <ClearBtn onClick={this.handleClearFilters}>
                          {copy.clear_all || <Placeholder w="100px" h="20px" />}
                        </ClearBtn>
                        <ApplyBtn onClick={this.handleToggleFilterOverlay}>
                          {copy.apply || <Placeholder w="100px" h="20px" />}
                        </ApplyBtn>
                      </FilterButtonWrapper>
                    </FilterMenuWrapper>
                  </Modal>
                )}
              </Fragment>
            ) : (
              <PlaceholderWrapper>
                <Placeholder h="72px" w="100%" />
              </PlaceholderWrapper>
            )}
          </MobileDropdownWrapper>

          <List>
            {seminars.length === 0 ? (
              <Placeholder h="190px" w="100%" />
            ) : (
              [...new Set(seminars.map(({ location, address }) => `${location}___${address}`))].map(cityAddress => (
                <Fragment key={cityAddress}>
                  <SeminarListHeader>
                    <Address>
                      {cityAddress.split('___')[0].toUpperCase()}: {cityAddress.split('___')[1]}
                    </Address>
                    <LinkWrapper>
                      {/* <Link to={`/${locale}/salon-locator`} href={`/${locale}/salon-locator`}>
                        {copy.open_in_map || <Placeholder w="100px" h="20px" />}
                      </Link> */}
                    </LinkWrapper>
                  </SeminarListHeader>
                  {generateSeminars(
                    seminars.filter(
                      seminar =>
                        seminar.location === cityAddress.split('___')[0] &&
                        seminar.address === cityAddress.split('___')[1]
                    ),
                    locale,
                    copy
                  )}
                </Fragment>
              ))
            )}
          </List>

          <SliderWrapper>
            {seminars.length === 0 ? (
              <Placeholder h="400px" w="100%" />
            ) : (
              <Slider options={{ loop: false }} dots={false}>
                {generateSeminars(seminars, locale, copy)}
              </Slider>
            )}
          </SliderWrapper>
        </SectionInner>
      </Section>
    );
  }
}

UpcomingSeminars.defaultProps = {
  copy: {},
};

UpcomingSeminars.propTypes = {
  copy: PropTypes.shape(),
  locale: PropTypes.string.isRequired,
  seminars: PropTypes.arrayOf(
    PropTypes.shape({
      address: PropTypes.string,
      city: PropTypes.string,
      date: PropTypes.string,
      name: PropTypes.string,
      category: PropTypes.string,
      targetAudience: PropTypes.arrayOf(PropTypes.string),
      photoGallery: PropTypes.arrayOf(PropTypes.shape({})),
      description: PropTypes.string,
      slug: PropTypes.string,
    })
  ).isRequired,
};

const mapState = state => ({
  copy: state.siteOptions.siteCopySeminarPage,
  locale: state.locale,
});

export default connect(mapState)(UpcomingSeminars);



// WEBPACK FOOTER //
// ./src/pages/SeminarPage/UpcomingSeminars/UpcomingSeminars.js